import { positionConstants } from "../constant/position.constants";

export const initialState = {
    position: {
        id: '',
        positionCode: '',
        positionName: ''
    },
    dataPosition: [
    ],
    errorCode: '',
    successCode: '',
    isLoading: false
};
const positionReducer = (state = initialState, action) => {
    switch (action.type) {
        case positionConstants.GET_SUCCESS:
            return {
                ...state,
                dataPosition: action.positionList,
                isLoading: false
            };
        case positionConstants.ADD_SUCCESS:
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };
        case positionConstants.ADD_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };
        case positionConstants.DELETE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case positionConstants.DELETE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        case positionConstants.UPDATE_SUCCESS:  
            return {
                ...state,
                successCode: action.code,
                isLoading: true
            };    
        case positionConstants.UPDATE_FAILURE:
            return {
                ...state,
                errorCode: action.error,
                isLoading: false
            };  
        default:
            return state;
    }
};

export default positionReducer;
